var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 14.5013H9.99609",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51237 6.99996C3.51154 6.40697 3.62809 5.81967 3.85529 5.27193C4.0825 4.72419 4.41587 4.22683 4.83619 3.80853C5.25651 3.39023 5.75546 3.05926 6.30429 2.83469C6.85312 2.61013 7.44097 2.4964 8.03395 2.50009C10.5083 2.51848 12.4875 4.57517 12.4875 7.05645V7.49996C12.4875 9.73844 12.9558 11.0374 13.3683 11.7473C13.4127 11.8232 13.4364 11.9094 13.4368 11.9974C13.4373 12.0853 13.4146 12.1718 13.371 12.2481C13.3274 12.3244 13.2644 12.3879 13.1884 12.4321C13.1124 12.4763 13.0261 12.4997 12.9382 12.5H3.06116C2.97323 12.4997 2.88692 12.4763 2.81093 12.4321C2.73494 12.3879 2.67197 12.3244 2.62835 12.248C2.58473 12.1717 2.56202 12.0852 2.56251 11.9973C2.56299 11.9093 2.58666 11.8231 2.63112 11.7472C3.04382 11.0373 3.51237 9.73832 3.51237 7.49996L3.51237 6.99996Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.f5613146a28a0ecd98d39b879ab5b881.svg";
export { ForwardRef as ReactComponent };